// สถิติรวมของผู้เล่นทั้งหมด: รูปแบบข้อมูลที่หน้าเกมกับ Worker ใช้ร่วมกัน (src/worker/api/stats.ts)

import { summarize } from "../engine/life";
import type { DeathCause, LifeState } from "../engine/types";

export const DEATH_CAUSES: readonly DeathCause[] = ["predator", "starvation", "disease", "accident", "disaster", "human", "old_age", "sacrifice"];

export interface LifeReport {
  speciesId: number;
  groupId: string;
  ageDays: number;
  offspring: number;
  reachedAdult: boolean;
  cause: DeathCause;
  km: number;
  generation: number;
}

export interface GlobalStats {
  lives: number;
  adults: number;
  offspring: number;
  ageDays: number;
  km: number;
  maxGeneration: number;
  causes: Record<DeathCause, number>;
}

export interface SpeciesStats {
  lives: number;
  adults: number;
  ageDays: number; // ผลรวม ใช้หาค่าเฉลี่ย
  bestAgeDays: number;
  offspring: number;
  bestOffspring: number;
  maxGeneration: number;
}

export interface StatsResponse {
  global: GlobalStats;
  groups: { groupId: string; lives: number; adults: number }[];
  species: SpeciesStats | null;
}

/** ข้อมูลที่ส่งไปบันทึกเมื่อจบชีวิต (มดงานไม่มีลูกของตัวเอง จึงส่งลูกเป็น 0) */
export function lifeReport(life: LifeState): LifeReport | null {
  const s = summarize(life);
  if (life.alive || !s.cause) return null;
  return {
    speciesId: life.species.id,
    groupId: life.species.groupId,
    ageDays: Math.round(s.ageDays * 10) / 10,
    offspring: life.flags.includes("role_worker") ? 0 : s.offspring,
    reachedAdult: s.reachedAdult,
    cause: s.cause,
    km: Math.round(life.geo?.km ?? 0),
    generation: life.lineage?.generation ?? 1,
  };
}
